export const TIMEOUT = 300000;
export const PAGE_LIMIT = 15;
export const PAGE_INITIAL = 0;
export const ORDER_INITIAL_HISTORICO = 'dataRegistroDiarioOficial';
export const { GESTOR_PUBLICACAO_DOE_NET } = window._env;
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
